import { cloneDeep } from "lodash";

export const convertValues = (key, Data, values) => {
  let copyData = cloneDeep(Data).otherInputsData;
  copyData[key] = values;
  return copyData;
};
